import cx from "classnames";
import { Text } from "@theorgchartdev/storybook";
import ActionListItem from "../../../../Composites/ActionListItem/ActionListItem";
import { GetWSMgr } from "@/Utils/StateLib";
import { appstr } from "@coreapp/utils/appstr";

export const UserNameLabel = ({ rowState, manager }) => {
  const baseTextClass = "ocn-folder-row-text";

  const user = rowState?.data;
  if (!user) return;

  const userID = user.username;
  const label = userID;
  const dataTestId = `user-row-${userID}`;

  const wsMgr = GetWSMgr();
  const curUser = wsMgr.GetUserName();
  let deleteTooltipProps = undefined;
  const disableDelete = userID === curUser;
  if (disableDelete) {
    deleteTooltipProps = {
      message: appstr("deleteself")
    };
  }

  const actions = [
    {
      dataTestId: `${dataTestId}-edit`,
      iconName: "pen",
      onClick: () => manager.editUser(user)
    },
    {
      dataTestId: `${dataTestId}-delete`,
      disabled: disableDelete,
      tooltipProps: deleteTooltipProps,
      iconName: "trash-can",
      iconProps: { color: "error" },
      onClick: () => manager.deleteUser(user)
    }
  ];

  const textContent = (
    <Text className={cx(baseTextClass)} size={"small"}>
      {label}
    </Text>
  );

  return <ActionListItem dataTestId={dataTestId} contentBefore={textContent} actions={actions} />;
};
